import Vue from 'vue';
import MobileMenu from './components/mobilemenu.vue';

const app = new Vue({
    el: '#global-nav',
    data(){
        return {
            menuShow: false,
            subMenuShow:false,
            trigger: 50,
            scrollY:0,
            lastScrollY:0,
        }
    },
    computed:{
        scrollingDown(){
            return this.scrollY > this.lastScrollY;
        },
        isOverTrigger(){
            return this.scrollY >= 80;
        },
        showBar(){
            return this.isOverTrigger && !this.scrollingDown;
        },
        hideBar(){
            return this.isOverTrigger && this.scrollingDown;
        },
    },
    components: {
        'mobile-menu': MobileMenu,
    },
    methods: {
        openMenu() {

        },
        closeMenu() {
            this.menuShow = false;
            this.subMenuShow = false;
        },
        toggleMenu() {
            this.menuShow = !this.menuShow;
        },
        toggleSubMenu() {
            this.subMenuShow = !this.subMenuShow;
        },
    },
    watch: {
        menuShow(value) {
            if (value) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        },
        subMenuShow(value) {
            if (value) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        },
    },
    mounted(){
        window.addEventListener('scroll', e => {
            this.lastScrollY = this.scrollY;
            this.scrollY = window.scrollY;
        })
    }
});
